import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Slider } from 'antd';

import ButtonWithIcon from '../ButtonWithIcon/ButtonWithIcon';

import styles from './LocationFilterDropdown.module.scss';

const LocationFilterDropdown = ({
  sliderValue,
  setSliderValue,
  isUsHeadquarter,
  onSearchClick,
  setIncludeRemote,
  includeRemote,
  setIsLocationMenuOpen,
}) => {
  const { t } = useTranslation('common');
  const getDisplayValue = (value, usHeadquarter) => {
    const unit = usHeadquarter ? t('units.miles') : t('units.km');
    if (value === 0) return t('locationFilter.exact');
    if (value === 250) return `250+ ${unit}`;
    return `${value} ${unit}`;
  };

  const handleShowResults = () => {
    onSearchClick(includeRemote);
    setIsLocationMenuOpen(false);
  };

  return (
    <div className={styles.locationMenuDropdown}>
      <div className={styles.sliderContainer}>
        <span className={styles.sliderLabel}>
          <b>{t('locationFilter.radius')}:</b> {getDisplayValue(sliderValue, isUsHeadquarter)}
        </span>
        <Slider
          min={0}
          max={250}
          value={sliderValue}
          onChange={(value) => setSliderValue(value)}
          tooltip={false}
          style={{ width: 120 }}
        />
      </div>

      <div className={styles.checkboxContainer}>
        <Checkbox checked={includeRemote} onChange={(e) => setIncludeRemote(e.target.checked)}>
          {t('locationFilter.includeRemote')}
        </Checkbox>
      </div>

      <div className={styles.buttonContainer}>
        <ButtonWithIcon
          text={t('buttons.showResults')}
          variant="primary-36"
          textClassName="btn-icon-text-primary-40"
          onClick={handleShowResults}
        />
      </div>
    </div>
  );
};

export default LocationFilterDropdown;
